import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

export default function FilteredTableLayout({
  toolbar,
  count,
  itemName,
  hasActiveFilters = false,
  onResetFilters,
  resetLabel = 'Reset filters',
  trailing,
  children,
  className
}: {
  toolbar: ReactNode;
  count: number;
  itemName: { singular: string; plural: string };
  hasActiveFilters?: boolean;
  onResetFilters?: () => void;
  resetLabel?: string;
  trailing?: ReactNode;
  children: ReactNode;
  className?: string;
}) {
  const noun = count === 1 ? itemName.singular : itemName.plural;
  const verb = count === 1 ? 'matches' : 'match';

  return (
    <div className={twMerge('flex min-w-0 flex-1 flex-col gap-2', className)}>
      <div className="@container flex w-full min-w-0 items-center gap-2">{toolbar}</div>
      <div className="flex flex-col gap-2">
        <div className="flex min-w-0 flex-wrap items-center justify-between gap-x-3 gap-y-1 text-xs text-content-subtle">
          <div className="flex min-w-0 items-center gap-2 min-h-6">
            <span>
              {count} {noun}
              {hasActiveFilters ? ` ${verb} your filters` : ''}
            </span>
            {hasActiveFilters && onResetFilters && (
              <>
                <span>·</span>
                <button type="button" onClick={onResetFilters} className="underline text-misc-link">
                  {resetLabel}
                </button>
              </>
            )}
          </div>
          {trailing}
        </div>
        {children}
      </div>
    </div>
  );
}
